import { NotifyGroupInput } from '@/types/notify-group';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function notifyGroup(axios: any) {
  async function getNotifyGroups(filter: any) {
    try {
      const response = await axios.get(`/api/line_groups?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/notify-group] getNotifyGroups Error', e);
    }
    return null;
  }

  async function getNotifyGroup(id: number) {
    const response = await axios.get(`/api/line_groups/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/notify-group] getNotifyGroup Error', e);
    }
    return null;
  }

  async function createNotifyGroup(payload: NotifyGroupInput) {
    const response = await axios.post('/api/line_groups', camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/notify-group] createNotifyGroup Error', e);
    }
    return null;
  }

  async function updateNotifyGroup(id: number | string, payload: NotifyGroupInput) {
    const response = await axios.put(`/api/line_groups/${id}`, camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/notify-group] updateNotifyGroup Error', e);
    }
    return null;
  }

  async function deleteNotifyGroup(id: number) {
    const response = await axios.delete(`/api/line_groups/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/notify-group] deleteNotifyGroup Error', e);
    }
    return null;
  }

  return {
    getNotifyGroups,
    getNotifyGroup,
    createNotifyGroup,
    updateNotifyGroup,
    deleteNotifyGroup,
  };
}
